module.exports = __webpack_public_path__ + "static/media/20b-04_ST-2020-325x427mm-oleo-sobre-madera.05d00858.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/20b/20b-04_ST-2020-325x427mm-oleo-sobre-madera.png
// module id = 249
// module chunks = 0